import { LocalStorageAPI } from 'API/LocalStoreApi';
import { ePersonalizationKeys } from './ePersonalizationKeys';

export const PersonalizationApi = LocalStorageAPI.injectEndpoints({
  endpoints: (build) => ({
    getRoleFilter: build.query<string[], void>({
      query: () => ({
        url: ePersonalizationKeys.TaskRoleFilters,
        method: 'GET',
      }),
      providesTags: () => [{ type: ePersonalizationKeys.TaskRoleFilters }],
    }),
    putRoleFilters: build.mutation<void, string[]>({
      query: (roleFilters) => ({
        url: ePersonalizationKeys.TaskRoleFilters,
        method: 'PUT',
        body: roleFilters,
      }),
      invalidatesTags: () => [{ type: ePersonalizationKeys.TaskRoleFilters }],
    }),
    getPersonFilter: build.query<string[], void>({
      query: () => ({
        url: ePersonalizationKeys.TaskPersonFilter,
        method: 'GET',
      }),
      providesTags: () => [{ type: ePersonalizationKeys.TaskPersonFilter }],
    }),
    putPersonFilter: build.mutation<void, string[]>({
      query: (personFilters) => ({
        url: ePersonalizationKeys.TaskPersonFilter,
        method: 'PUT',
        body: personFilters,
      }),
      invalidatesTags: () => [{ type: ePersonalizationKeys.TaskPersonFilter }],
    }),
  }),
});

export const { useGetRoleFilterQuery, usePutRoleFiltersMutation, useGetPersonFilterQuery, usePutPersonFilterMutation } =
  PersonalizationApi;
